import styled from 'styled-components';

export const Button = styled.button`
box-sizing:border-box;
background: #FFE600;
color: #002A30;
margin: 0.625rem;
padding: 0.5em 1em;
border-radius: 50px;
box-shadow: 0px 2.24635px 2.24635px rgba(0, 0, 0, 0.25);
min-width:max-content;
font-size: 1.6em;
`;